import { gql, useMutation } from '@apollo/client'
import { UserCreate } from 'shared/__gql-types'


export const CREATE_USER = gql`
  mutation ($input: UserCreate) {
    createUser(input: $input) {
      id
    }
  }
`

export const useCreateUser = () => {
  const [mutate, { data, loading, error }] = useMutation<
  { createUser: { id: string }},
  { input: UserCreate }
>(CREATE_USER, {
  update(cache) {
    cache.modify({
      fields: {
        listUsers() {}
      }
    })
  }
})

  return { mutate, data, loading, error }
}
